import React, { useEffect, useRef } from "react";
import { ReactGoogleReviews } from "react-google-reviews";
import "react-google-reviews/dist/index.css";

export const FEATURABLE_ID =
  "97d9a9af-70fd-496f-920b-1686929aab42";


const ReviewCarousel = ({ reviews, limit }) => {
  const sliderRef = useRef(null);

  const visibleReviews = reviews.slice(0, limit);

  useEffect(() => {
    if (visibleReviews.length < 3) return;

const interval = setInterval(() => {
  const slider = sliderRef.current;
  const card = slider?.querySelector(".testimonial-card");

  if (!slider || !card) return;

  const sliderStyles = getComputedStyle(slider);
  const gap = parseFloat(sliderStyles.gap) || 0;
  const cardWidth = card.getBoundingClientRect().width + gap;

  const maxScroll = slider.scrollWidth - slider.clientWidth;

  if (slider.scrollLeft >= maxScroll - 5) {
    slider.scrollTo({
      left: 0,
      behavior: "smooth",
    });
  } else {
    slider.scrollTo({
      left: slider.scrollLeft + cardWidth,
      behavior: "smooth",
    });
  }
}, 4000);

    return () => clearInterval(interval);
  }, [visibleReviews.length]);
  return (
    <div className="google-reviews-carousel">
      <div className="google-reviews-slider" ref={sliderRef}>
        {visibleReviews.map((review, index) => {
  return (
    <article
      className="testimonial-card"
      key={review.reviewId || index}
    >
            <div className="testimonial-card-row">
              <div className="profile-icon-wrapper">
               <img
  src={review.reviewer?.profilePhotoUrl}
  alt={review.reviewer?.displayName || "Google User"}
  referrerPolicy="no-referrer"
/>
              </div>

              <div className="testimonial-card-col">
                <h3 className="card-heading">
                  {review.reviewer?.displayName || "Google User"}
                </h3>

                <div className="google-review-stars">
                  {"★".repeat(
                    Math.max(0, Math.min(5, review.starRating || 5))
                  )}
                </div>
              </div>
            </div>

            <p className="section-text">
              {review.comment || "No written review provided."}
            </p>
          </article>
       );
})}
      </div>
    </div>
  );
};

const GoogleReviews = ({ layout = "grid", limit = 12 }) => {
  return (
    <ReactGoogleReviews
      featurableId={FEATURABLE_ID}
      layout="custom"
      renderer={(reviews) => {
        if (layout === "slider") {
          return (
            <ReviewCarousel reviews={reviews} limit={limit} />
          );
        }
        return (
          <div className="google-reviews-grid">
            {reviews.slice(0, limit).map((review, index) => {
  return (
    <article
      className="testimonial-card"
      key={review.reviewId || index}
    >
                <div className="testimonial-card-row">
                <div className="profile-icon-wrapper">
  {review.reviewer?.profilePhotoUrl ? (
    <img
      src={review.reviewer.profilePhotoUrl}
      alt={review.reviewer.displayName || "Google User"}
      referrerPolicy="no-referrer"
    />
  ) : (
    <div className="profile-avatar-fallback">
      {(review.reviewer?.displayName || "G")
        .charAt(0)
        .toUpperCase()}
    </div>
  )}
</div>

                  <div className="testimonial-card-col">
                    <h3 className="card-heading">
                      {review.reviewer?.displayName || "Google User"}
                    </h3>

                    <div className="google-review-stars">
                      {"★".repeat(
                        Math.max(0, Math.min(5, review.starRating || 5))
                      )}
                    </div>
                  </div>
                </div>

                <p className="section-text">
                  {review.comment || "No written review provided."}
                </p>
           </article>
  );
})}
          </div>
        );
      }}
    />
  );
};

export default GoogleReviews;
